import React, { useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

import { SessionContext } from "../context/session-context";
import { UserContext } from "../context/user-context";

const useStyles = makeStyles({
    root: {
      paddingRight:20,
      paddingTop:12,
      color: '#000',
    },
    shoppingIcon: {
      width: 24,
      height: 24,
      padding:0,
      color:'#000'
    },
  });

export default function LoggedInPaper(props) {
  const classes = useStyles();
  const [state, dispatch] = useContext(SessionContext);
  const [uState, udispatch] = useContext(UserContext);
  const [balance, setBalance] = useState(10.00);
  
  return (
    <div className={classes.root}>
        <Box display="flex" >
        <ShoppingCartIcon className={classes.shoppingIcon}/>
        <Box fontWeight="fontWeightBold" fontSize={14}>£{balance}</Box>
      </Box>
    </div>
  );
}